import React, {useContext} from "react";
import {Box, Card, Stack, Typography} from "@mui/material";
import {
  BASE_WORLD_REGISTER_STEPS,
  BaseWorldRegisterPayload,
  CONTEXT_ACTION_TYPE,
  DataStoreContext
} from "../../contexts/OperatingEnvironmentContext";
import useMutation from "../../../../hooks/useMutation";
import Pjdb1ImputEx from "../../../../components/inputs/Pjdb1ImputEx";
import WithLabel from "../forms/WithLabel";
import Pjdb1Button from "../../../../components/inputs/Pjdb1Button";
import Pjdb1TextField from "../../../../components/inputs/Pjdb1TextField";
import {registerWorld} from "../../../../utils/awsAmplifyUtil";
import {WORLD_TYPES} from "../../../../types/pj1dbApiWorld";

export default function BaseWorldRegisterWorldNameInputStep() {
  const {state, dispatch} = useContext(DataStoreContext);
  const {mutate, formRef, isLoading} = useMutation({
    enableConfirm: false,
    successMsg: 'ベースワールドの登録完了',
    mutationFn: async () => {
      if (state.baseWorldRegister.s3Uri === null) {
        return 'アップロード済みのベースワールドのURIが取得できないため登録を中断しました。初めからやり直してください。';
      }

      // 1. Register base world
      const removedFilenameUri = `${state.baseWorldRegister.s3Uri.split('/').slice(0, -1).join('/')}/`;
      const registerRes = await registerWorld({
        pathParams: {version: 'object-user'},
        body: {
          "s3-uri": removedFilenameUri,
          "world-type": WORLD_TYPES.BASE,
          "name-jp": state.baseWorldRegister.inputs.worldName,
        }
      });

      return registerRes.isSuccess;
    },
  });

  return (
    <Card sx={{p: 3, width: '100%'}}>
      <Stack gap={4}>
        <Box display='flex' flexWrap='wrap' gap={2} alignItems='flex-end' justifyContent='space-between'>
          <Typography variant="h6">ベースワールド</Typography>
          <Pjdb1ImputEx/>
        </Box>

        <Box>
          <Typography
            variant="body2">GazeboUIでベースワールド保存完了後。ワールド名を指定して登録を完了してください。</Typography>
        </Box>

        <form ref={formRef}>
          <Stack gap={2}>
            <WithLabel label='ワールド名'>
              <Pjdb1TextField
                label=''
                name='worldName'
                required
                value={state.baseWorldRegister.inputs.worldName}
                onChange={(event) => {
                  dispatch({
                    type: CONTEXT_ACTION_TYPE.BASE_WORLD_REGISTER,
                    payload: {
                      inputs: {
                        ...state.baseWorldRegister.inputs,
                        worldName: event.target.value
                      }
                    } satisfies BaseWorldRegisterPayload
                  });
                }}
                toolTip={(<Box>文字列<br/>作成したベースワールドの名称</Box>)}
              />
            </WithLabel>

          </Stack>
        </form>

        <Box component="section" sx={{textAlign: "center"}}>
          <Pjdb1Button
            label="戻る"
            variant="contained"
            color="inherit"
            isLoading={isLoading}
            sx={{m: 2}}
            onClick={() => {
              dispatch({
                type: CONTEXT_ACTION_TYPE.BASE_WORLD_REGISTER,
                payload: {
                  step: BASE_WORLD_REGISTER_STEPS.MODEL_SELECTION_STEP,
                } satisfies BaseWorldRegisterPayload
              });
            }}
          />
          <Pjdb1Button
            label="ベースワールド登録"
            variant="contained"
            color="primary"
            isLoading={isLoading}
            sx={{m: 2}}
            onClick={() => {
              mutate().catch(console.error)
            }}
          />
        </Box>
      </Stack>
    </Card>
  );
}
